<template>
  <v-navigation-drawer
    :value="isLeftNavDrawer"
    dark
    color="secondary"
    :fixed="true"
    :right="right"
    :clipped="$vuetify.breakpoint.lgAndUp"
    :disable-resize-watcher="disableResizeWatcher"
    :mini-variant.sync="mini"
    app
  >
    <v-list class="pt-0 mt-2" dense>
      <!-- SINGLE ELEMENTS TOP-->
      <v-list-tile
        v-for="element in appNavDrawElementsTop"
        v-if="element.type === 'single'"
        :key="element.title"
      >
        <v-list-tile-action>
          <v-icon>{{ element.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title class="nav-group-title">
            <strong> {{ element.title }} </strong>
          </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon @click.stop="reduceNavDrawer()">
            <v-icon>chevron_left</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>

      <!-- GROUPS ELEMENTS -->
      <v-list-group
        v-for="element in appNavDrawElements"
        v-if="element.type === 'group'"
        v-model="element.active"
        active-class="white--text"
        :prepend-icon="element.icon"
        append-icon="keyboard_arrow_down"
        value="true"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title class="nav-group-title">
            <strong>{{ element.title }}</strong>
          </v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="subElement in element.subElements"
          :key="subElement.title"
          class="ml-3"
          @click="navigate(subElement.path)"
        >
          <v-list-tile-action>
            <v-icon>{{ subElement.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ subElement.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>

      <!-- DIVIDER -->
      <!--<v-divider></v-divider>-->

      <!-- SINGLE ELEMENTS -->
      <v-list-tile
        v-for="element in appNavDrawElements"
        v-if="element.type === 'single'"
        :key="element.title"
        @click="navigate(element.path)"
      >
        <v-list-tile-action>
          <v-icon>{{ element.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>{{ element.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!-- CLOSING DRAWER BUTTON -->
      <v-list-tile v-if="mini">
        <v-btn icon @click.stop="setMini(false)">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import RouterService from "@/helpers/RouterService";

export default {
  name: "NavigationDrawer",
  props: ["right"],
  computed: {
    ...mapState({}),
    ...mapGetters("AppState", {
      miniStore: "isLeftNavDrawerMini",
      isLeftNavDrawer: "isLeftNavDrawer",
    }),
    ...mapGetters("UserState", {
      settings: "getSettings",
      userInfo: "getUserInfo",
    }),
    appNavDrawElements() {
      let filteredAppNavDrawerElements = undefined;
      /*if (this.$route.path.includes("/lab")) {
            filteredAppNavDrawerElements = this.appNavDrawElementsLab["LAB"];
        } else {
            filteredAppNavDrawerElements = this.appNavDrawElementsAll[this.userInfo.role];
        }*/
      filteredAppNavDrawerElements =
        this.appNavDrawElementsAll[this.userInfo.role];

      let _this = this;
      filteredAppNavDrawerElements = filteredAppNavDrawerElements.filter(
        function (element) {
          return _this.settings.settingsFilter.indexOf(element.id) === -1;
        }
      );
      return filteredAppNavDrawerElements;
    },
  },
  data() {
    return {
      mini: false,
      disableResizeWatcher: true,
      appNavDrawElementsTop: [
        {
          type: "single",
          id: "home",
          title: "",
          icon: "",
          path: "/admin/homepage",
        },
      ],
      appNavDrawElementsLab: {
        LAB: [
          // Application navigation drawer elements  related to the LAB
        ],
      },
      appNavDrawElementsAll: {
        IVE_ADMIN: [],
        ADMIN: [
          {
            type: "group",
            id: "admin-training",
            title: "Conversation",
            active: false,
            icon: "mdi-chat",
            subElements: [
              {
                type: "single",
                id: "admin-training-conversation",
                title: this.$i18n.t("training.conversation.title"),
                icon: "mdi-forum",
                path: "/admin/training/dialogs",
              },
              {
                type: "single",
                id: "admin-forum-outline",
                title: this.$i18n.t("testing.talk.title"),
                icon: "mdi-message-processing",
                path: "/admin/testing/dialogs",
              },
              {
                type: "single",
                id: "admin-plugins",
                title: "IVE Plugins",
                icon: "mdi-puzzle",
                path: "/admin/training/plugins",
              },
              {
                type: "single",
                id: "admin-training-uploadStartups",
                title: "Upload Startups file",
                icon: "mdi-table-large",
                path: "/admin/training/dialogs/upload-startups",
              },

              {
                type: "single",
                id: "admin-training-historyChatStartups",
                title: "History chat",
                icon: "mdi-history",
                path: "/admin/training/dialogs/history-chat-startups",
              },
            ],
          },
          {
            type: "single",
            id: "iadmin-groupManagement",
            title: "Group Management",
            icon: "mdi-account-group",
            path: "/iadmin/groupManagement",
          },
         {
            type: "single",
            id: "iadmin-userManagement",
            title: "User Management",
            icon: "mdi-account-plus",
            path: "/iadmin/userManagement",
          },
          {
            type: "single",
            id: "iadmin-startupmanagement",
            title: "Startup Management",
            icon: "mdi-briefcase-account",
            path: "/iadmin/startupManagement",
          },
          {
            type: "single",
            id: "iadmin-startupsearch",
            title: "Startup Search",
            icon: "mdi-briefcase-search",
            path: "/iadmin/startupSearch",
          },
          {
            type: "single",
            id: "iadmin-startupsearch",
            title: "Synonyms",
            icon: "menu_book",
            path: "/iadmin/Synonyms",
          },
          {
            type: "single",
            id: "operations-history",
            title: "Operations History",
            icon: "mdi-check-outline", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/iadmin/operationsHistory",
          },
          {
            //da modificare anche in ADMIN_INNOVATION
            type: "single",
            id: "iadmin-challenge-management",
            title: "Challenge Management",
            icon: "mdi-flag-outline", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/iadmin/challengeManagement",
          },
          {
            type: "single",
            id: "iadmin-news-management",
            title: "News Management",
            icon: "mdi-newspaper", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/iadmin/newsManagement",
          },
          {
            type: "single",
            id: "approver-management",
            title: "Approver Operation Management",
            icon: "mdi-check-outline", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/approver/operationManagement",
          },
          {
            type: "single",
            id: "ghost-contacts-table",
            title: "Ghost page contacts",
            icon: "mdi-contacts", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/approver/contacts",
          },
          /*{
            type: "single",
            id: "trend-radar",
            title: "Trend Radar",
            icon: "mdi-radar", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/radar",
          },*/
          {
            type: "single",
            id: "newupload",
            title: "Excels Startup Upload",
            icon: "mdi-table-large",
            path: "/iadmin/excel-upload/",
          },
        ],
        USER: [
          // Application navigation drawer elements related to the USER
          {
            type: "single",
            id: "user-dialogs",
            title: "Dialogs",
            icon: "mdi-forum",
            path: "/user/dialogs",
          },
          {
            type: "single",
            id: "user-files",
            title: "Files",
            icon: "mdi-file-document-box-multiple",
            path: "/user/files",
          },
        ],
        USER_CHAT: [
          // Application navigation drawer elements related to the USER CHAT
          {
            type: "single",
            id: "user-dialogs",
            title: "Dialogs",
            icon: "mdi-forum",
            path: "/user/dialogs",
          },
        ],
        USER_INNOVATION: [
          // Application navigation drawer elements related to the USER INNOVATION
          {
            type: "single",
            id: "user-dialogs",
            title: "Chat",
            icon: "mdi-forum",
            path: "/user/dialogs",
          },

          /*{
            type: "single",
            id: "trend-radar",
            title: "Trend Radar",
            icon: "mdi-radar", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/radar",
          },*/
          /*{
            type: "single",
            id: "feedback",
            title: "Feedback Page",
            icon: "mdi-star-outline",
            path: "/iadmin/feedback-page",
          },*/
        ],
        CUSTOMER_INNOVATION: [
          // Application navigation drawer elements related to the CUSTOMER INNOVATION
          {
            type: "single",
            id: "iadmin-challenge-management",
            title: "Challenge Management",
            icon: "mdi-flag-outline",
            path: "/iadmin/challengeManagement",
          },
          /*{
            type: "single",
            id: "feedback",
            title: "Feedback Page",
            icon: "mdi-star-outline",
            path: "/iadmin/feedback-page",
          },*/
        ],
        APPROVER_INNOVATION: [
          // Application navigation drawer elements related to the APPROVER_INNOVATION
          {
            type: "single",
            id: "user-dialogs",
            title: "Chat",
            icon: "mdi-forum",
            path: "/user/dialogs",
          },
          {
            type: "single",
            id: "admin-training-uploadStartups",
            title: "Upload Startups file",
            icon: "mdi-table-large",
            path: "/admin/training/dialogs/upload-startups",
          },
          {
            type: "single",
            id: "admin-training-historyChatStartups",
            title: "History chat",
            icon: "mdi-history",
            path: "/admin/training/dialogs/history-chat-startups",
          },
          {
            type: "single",
            id: "iadmin-groupManagement",
            title: "Group Management",
            icon: "mdi-account-group",
            path: "/iadmin/groupManagement",
          },
          {
            type: "single",
            id: "iadmin-userManagement",
            title: "User Management",
            icon: "mdi-account-plus",
            path: "/iadmin/userManagement",
          },
          {
            type: "single",
            id: "iadmin-startupmanagement",
            title: "Startup Management",
            icon: "mdi-briefcase-account",
            path: "/iadmin/startupManagement",
          },
          {
            type: "single",
            id: "iadmin-challenge-management",
            title: "Challenge Management",
            icon: "mdi-flag-outline",
            path: "/iadmin/challengeManagement",
          },
          {
            type: "single",
            id: "iadmin-news-management",
            title: "News Management",
            icon: "mdi-newspaper", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/iadmin/newsManagement",
          },
          {
            type: "single",
            id: "iadmin-startupsearch",
            title: "Synonyms",
            icon: "menu_book",
            path: "/iadmin/Synonyms",
          },
          {
            type: "single",
            id: "approver-management",
            title: "Approver Operation Management",
            icon: "mdi-check-outline", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/approver/operationManagement",
          },
          {
            type: "single",
            id: "ghost-contacts-table",
            title: "Ghost page contacts",
            icon: "mdi-contacts", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/approver/contacts",
          },
          {
            type: "single",
            id: "newupload",
            title: "Excels Startup Upload",
            icon: "mdi-table-large",
            path: "/iadmin/excel-upload/",
          },
          /*{
            type: "single",
            id: "feedback",
            title: "Feedback Page",
            icon: "mdi-star-outline",
            path: "/iadmin/feedback-page",
          },*/
          /*{
            type: "single",
            id: "review",
            title: "Review Page",
            icon: "mdi-comment-text-outline",
            path: "/iadmin/review-page",
          },*/
          /*{
            type: "group",
            id: "radar-group",
            title: "Radar",
            active: false,
            icon: "mdi-radar",
            subElements: [
              {
                type: "single",
                id: "trend-radar",
                title: "Trend Radar",
                icon: "mdi-radar", //mdi-star, mdi-star-circle, mdi-star-outline
                path: "/radar",
              },
              {
                type: "single",
                id: "radar-trend-list",
                title: "Trend Management",
                icon: "mdi-format-list-checkbox", //mdi-star, mdi-star-circle, mdi-star-outline
                path: "/radar/list",
              },
            ],
          },*/
        ],
        /*RADAR_INNOVATION: [
          // Application navigation drawer elements related to the RADAR_INNOVATION

          {
            type: "single",
            id: "trend-radar",
            title: "Trend Radar",
            icon: "mdi-radar", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/radar",
          },
        ],*/
        CUSTOMER_CHAT_INNOVATION: [
          // Application navigation drawer elements related to the CUSTOMER CHAT INNOVATION
          {
            type: "single",
            id: "iadmin-challenge-management",
            title: "Challenge Management",
            icon: "mdi-flag-outline",
            path: "/iadmin/challengeManagement",
          },
          {
            type: "single",
            id: "user-dialogs",
            title: "Chat",
            icon: "mdi-forum",
            path: "/user/dialogs",
          },
        ],
        ADMIN_INNOVATION: [
          // Application navigation drawer elements related to the ADMIN INNOVATION
          {
            type: "single",
            id: "user-dialogs",
            title: "Chat",
            icon: "mdi-forum",
            path: "/user/dialogs",
          },
          {
            type: "single",
            id: "admin-training-historyChatStartups",
            title: "History chat",
            icon: "mdi-history",
            path: "/admin/training/dialogs/history-chat-startups",
          },
          {
            type: "single",
            id: "iadmin-groupManagement",
            title: "Group Management",
            icon: "mdi-account-group",
            path: "/iadmin/groupManagement",
          },
          /*{
            type: "single",
            id: "iadmin-userManagement",
            title: "User Management",
            icon: "mdi-account-plus",
            path: "/iadmin/userManagement",
          },*/
         {
            type: "single",
            id: "iadmin-startupmanagement",
            title: "Startup Management",
            icon: "mdi-briefcase-account",
            path: "/iadmin/startupManagement",
          },
          {
            type: "single",
            id: "iadmin-startupsearch",
            title: "Startup Search",
            icon: "mdi-briefcase-search",
            path: "/iadmin/startupSearch",
          },
          {
            type: "single",
            id: "operations-history",
            title: "Operations History",
            icon: "mdi-playlist-check", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/iadmin/operationsHistory",
          },
          /*{
            type: "single",
            id: "trend-radar",
            title: "Trend Radar",
            icon: "mdi-radar", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/radar",
          },*/

          {
            type: "single",
            id: "iadmin-challenge-management",
            title: "Challenge Management",
            icon: "mdi-flag-outline",
            path: "/iadmin/challengeManagement",
          },
          {
            type: "single",
            id: "iadmin-news-management",
            title: "News Management",
            icon: "mdi-newspaper", //mdi-star, mdi-star-circle, mdi-star-outline
            path: "/iadmin/newsManagement",
          },
          /*{
            type: "single",
            id: "feedback",
            title: "Feedback Page",
            icon: "mdi-star-outline",
            path: "/iadmin/feedback-page",
          },*/
          /*{
            type: "single",
            id: "review",
            title: "Review Page",
            icon: "mdi-comment-text-outline",
            path: "/iadmin/review-page",
          },*/
          {
            type: "single",
            id: "iadmin-startupsearch",
            title: "Synonyms",
            icon: "menu_book",
            path: "/iadmin/Synonyms",
          },
          {
            type: "single",
            id: "newupload",
            title: "Excels Startup Upload",
            icon: "mdi-table-large",
            path: "/iadmin/excel-upload/",
          }
        ],
      },
    };
  },
  created() {
    this.reduceNavDrawer();
  },
  methods: {
    setMini(isMini) {
      this.mini = isMini;
    },
    navigate(path) {
      RouterService.goTo(path);
    },
    reduceNavDrawer() {
      this.setMini(true);
      for (let i = 0; i < this.appNavDrawElements.length; i++) {
        if (this.appNavDrawElements[i].type === "group") {
          this.appNavDrawElements[i].active = false;
        }
      }
      //this.$store.dispatch("AppState/setAppNavDrawerElementsAdmin", this.appNavDrawElements);
    },
  },
};
</script>

<style scoped>
.nav-group-title {
  font-size: 1.2em;
}
</style>
